import * as THREE from 'three';
import {
  CARD1Web,
  MouseAction
} from '../../CoordUtils.js';

export const ArrowType = {
    Direct: 1,
    LeftTurn:2,
    RightTurn:3,
    TurnRound:4
}
export class ArrowLoader {
  constructor(arrowOption, sceneManager) {
    this.sceneManager = sceneManager;
    this.modelMesh = this.draw(arrowOption);                                                                                         
  }

  draw(arrowOption) {
    var shape = this.getArrowShape(arrowOption.shapeType);
    var arrowGeometry = new THREE.ShapeGeometry(shape);
    this.lineMaterial = new THREE.MeshBasicMaterial({
      color: arrowOption.color
    });
    this.arrowMesh = new THREE.Mesh(arrowGeometry, this.lineMaterial);
    
    return this.arrowMesh;
  }

  getArrowShape(shapeType) {
    var pts = [];
   
    if (shapeType == ArrowType.Direct){
        pts.push(new THREE.Vector2(0, 0));
        pts.push(new THREE.Vector2(0.45, 0));
        pts.push(new THREE.Vector2(0.45, 5.4));
        pts.push(new THREE.Vector2(0.9, 5.4));
        pts.push(new THREE.Vector2(0.225, 9));
        pts.push(new THREE.Vector2(-0.45, 5.4));
        pts.push(new THREE.Vector2(0, 5.4));
    }
    else if (shapeType ==ArrowType.LeftTurn || shapeType ==ArrowType.RightTurn){
        var neg = ((shapeType ==ArrowType.LeftTurn) ? 1 : -1);
        pts.push(new THREE.Vector2(0, 0));
        pts.push(new THREE.Vector2(neg*0.45, 0));
        pts.push(new THREE.Vector2(neg*0.45, 4.5));
        pts.push(new THREE.Vector2(neg*1.65, 5.7));
        pts.push(new THREE.Vector2(neg*1.65, 4.35));
        pts.push(new THREE.Vector2(neg*2.25, 6.6));
        pts.push(new THREE.Vector2(neg*1.65, 9));
        pts.push(new THREE.Vector2(neg*1.65, 7.5));
        pts.push(new THREE.Vector2(0, 5.85)); 
    }
    
    return new THREE.Shape(pts);
  }

  loadModel() {
    return this.arrowMesh;
  }
  setStake(startStake, endStake, lookAtPt) {
  
    // TODO:计算旋转的角度
    this.arrowMesh.lookAt(lookAtPt);
    this.arrowMesh.rotateX(-Math.PI / 2);
    this.arrowMesh.rotateZ(Math.PI);
  }

}


// WEBPACK FOOTER //
// ./src/plugins/drawings3D/modelDrawing/DirectModel/ArrowLoader.js